import React, { Component } from "react";
import TimeUtil from "../../../Utils/TimeUtil";
import DataAPI from "../../../Utils/Api";
// import crossSvg from '../../../../assets/imgs/icons/cross-black.svg';
import showSnackBar from "../../BaseComponents/SnackBar";
import DoubleTick from "../../../../assets/imgs/icons/double-tick-icon.svg";

interface IProps {
  message;
  messageType;
  messageKey;
  data;
  extra;
  timeStamp;
  removeFeedbackOption;
}

class MessageFeedback extends Component<IProps, null> {
  selectThumbs(bool, ev) {
    var target = ev.target;

    DataAPI()
      .get("/update?key=" + target.getAttribute("data-key") + "&accept=" + bool)
      .then((response) => {
        target.parentElement.childNodes.forEach((element) => {
          if (element.nodeName == "DIV")
            element.classList.remove("thumbs-filled");
        });
        target.classList.add("thumbs-filled");
        if (bool) {
          showSnackBar("Thank you for the feedback");
        }
        if (!bool) {
          this.showCommentBox(bool, target);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showCommentBox(bool, target) {
    if (document.querySelector("#feedback-comment-box")) {
      document
        .querySelector("#feedback-comment-box")
        .parentElement.removeChild(
          document.querySelector("#feedback-comment-box")
        );
    }
    var key = target.getAttribute("data-key");
    var commentBox = document.createElement("div");
    commentBox.id = "feedback-comment-box";
    commentBox.innerHTML = `<div class='head'></div>`;
    var crossImg = document.createElement("img");
    crossImg.src = require("../../../../assets/imgs/icons/cross-black.svg");
    crossImg.addEventListener("click", function () {
      document
        .querySelector("#feedback-comment-box")
        .parentElement.removeChild(
          document.querySelector("#feedback-comment-box")
        );
    });
    crossImg.alt = "close comment box";
    commentBox.querySelector(".head").appendChild(crossImg);
    var form = document.createElement("form");
    form.innerHTML = `<input type="text" required placeholder="Type here to share your feedback"><button type="submit">Send</button>`;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var comment = form.querySelector("input").value.trim();
      DataAPI()
        .get(
          "/saveComment?key=" + key + "&type=" + bool + "&comment=" + comment
        )
        .then((response) => {
          showSnackBar("Thank you for the feedback");
          form.parentElement.parentElement.removeChild(form.parentElement);
        })
        .catch((error) => {
          console.log(error);
          form.parentElement.parentElement.removeChild(form.parentElement);
        });
    });
    commentBox.appendChild(form);
    target.parentElement.parentElement.appendChild(commentBox);
    form.querySelector("input").addEventListener("keypress", function (e) {
      var key = e.which || e.keyCode;
      if (
        (key >= 44 && key <= 57) ||
        (key >= 65 && key <= 90) ||
        (key >= 97 && key <= 122) ||
        key == 8 ||
        key == 13 ||
        key == 32 ||
        key == 39 ||
        key == 16 ||
        key == 20 ||
        key == 63
      ) {
      } else {
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    });
  }

  returnExtraData() {
    var toReturn;
    if (this.props.extra && this.props.extra.length > 0) {
      this.props.extra.map((d, i) => {
        toReturn =
          "Recognised Information:\nEntity: " +
          d.entity +
          "\nIntent: " +
          d.intent +
          "\nQuestion: " +
          d.question +
          "\nEntity Heirarchy: " +
          d.entity_heirarchy +
          "\nSemantics Identified: " +
          d.semantics +
          "\nVariations Matched :" +
          d.variationMatched +
          "\nIntent Score: " +
          d.intent_score +
          "\nIntent Not Match: " +
          d.intent_notmatch +
          "\nReverse Intent Score: " +
          d.reverseIntentScore +
          "\nReverse Intent Not Match: " +
          d.reverseintent_notmatch +
          "\nSemantic Sequence: " +
          d.semanticsequence +
          "\nContextEnable: " +
          d.entityinContext;
      });
    }
    if (this.props.data.isInsideAware) {
      return toReturn;
    }
  }

  render() {
    let shouldDisplayElipsis = false;
    if (Array.isArray(this.props.message)) {
      let isDisambTrue = this.props.message[4].disambFlag || false;
      let isInsideAware = this.props.data.isInsideAware;
      let extras = this.props.extra && this.props.extra.length > 0;
      shouldDisplayElipsis = isInsideAware && !isDisambTrue && extras;
    }
    let check_entity =
      this.props.message.length > 0 && this.props.message[0]
        ? this.props.message[0]
        : "";
    // console.log(this.props.removeFeedbackOption);
    return (
      <div
        className="sf-message-feedback"
        style={{
          justifyContent:
            this.props.messageType == "server" ? "space-between" : "flex-end",
        }}
      >
        <div className="sf-time-wrapper">
          {this.props.timeStamp}
          &nbsp;&nbsp;
          {/* added double tick here. */}
          {this.props.messageType == "server" ? null : (
            <img src={DoubleTick} style={{ width: "14px" }}></img>
          )}
        </div>

        {this.props.messageType == "server" &&
        !(
          this.props.removeFeedbackOption ||
          check_entity.EntityName === "SelfIntroductionEntity" ||
          check_entity.EntityName === "Generic Question" ||
          check_entity.EntityName === "Generic Utterance"
        ) ? (
          <div className="sf-thumbs-wrapper">
            <div
              className="sf-thumbs sf-thumbs-up"
              data-key={this.props.messageKey}
              onClick={this.selectThumbs.bind(this, true)}
            ></div>
            <div
              className="sf-thumbs sf-thumbs-down"
              data-key={this.props.messageKey}
              onClick={this.selectThumbs.bind(this, false)}
            ></div>
            {/* {
                            isASenseforthDomain() ?
                                <span title={JSON.stringify(this.props.message).replace(/(\[|\]|{|})/g,"")}>...</span>
                            : null
                        } */}
            {shouldDisplayElipsis ? (
              <div
                className="sf-thumbs elipsis"
                title={this.returnExtraData()}
              ></div>
            ) : (
              ""
            )}
            {/* {ShowDoubleTick ? <div className="sf-thumbs elipsis" title={this.returnExtraData()}>
                        </div> : ''} */}
          </div>
        ) : null}
      </div>
    );
  }
}

export default MessageFeedback;

function isASenseforthDomain() {
  return (
    location.origin.indexOf("aware.senseforth.com") >= 0 ||
    //location.origin.indexOf("localhost") >=0 ||
    location.origin.indexOf("159.65.186.219") >= 0
  );
}
